import React from 'react';
import { Helmet } from 'react-helmet';
import RandomImage from './components/RandomImage';
import ShareButton from './components/ShareButton';

const App = () => {
  const handleShare = (imageUrl) => {
     // Define the meta tags to be updated
    const metaTags = [
      { property: 'og:title', content: 'Random Image' },
      { property: 'og:description', content: 'A random image generated by the app.' },
      { property: 'og:image', content: imageUrl },
      { property: 'og:image:width', content: '600' },
      { property: 'og:image:height', content: '400' },
      { property: 'og:image:alt', content: 'Random Image' },
    ];

    // Remove any existing meta tags and add the updated ones
    Helmet.removeAll();
    metaTags.forEach((tag) => Helmet.addTag(tag));
  };

  return (
    <div>
      {/* Render the RandomImage component and pass the handleShare function */}
      <RandomImage onImageLoad={handleShare} />
      
       {/* Render the ShareButton component */}
      <ShareButton />
    </div>
  );
};

export default App;
